import React from 'react';
import { getClassName } from 'utils/ui/classes';
const baseClass = 'px-4 py-5 sm:p-6 overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6 text-base font-normal text-gray-500';
const SimpleCard = ({ title, children, className, dataTestId }) => (React.createElement("div", { "data-testid": dataTestId, className: getClassName(baseClass, className) },
    React.createElement("dt", { "data-testid": "dt-36eef7ca", className: "text-sm font-normal text-gray-500" }, title),
    React.createElement("dd", { "data-testid": "dd-cf923438", className: "mt-1 flex justify-between items-baseline md:block lg:flex" }, children)));
export default SimpleCard;
